import React from 'react';

import { flagStyles } from '../settings';

const SvgAW = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-288px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAW;
